import * as trialSettingsService from '../services/trialSettings';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
	isFetching: false,
	fetchingError: null,

	minAllowedViewerVersion: null,
	onceAYear: null,
};

const sliceName = 'trialSettings';

export const getTrialSettings = createAsyncThunk(
	`${sliceName}/getTrialSettings`,
	(args, thunkAPI) => {
		return trialSettingsService.getTrialSettings().catch((error) => {
			error.clientMessage = "Can't get trial settings from server";
			return thunkAPI.rejectWithValue(error);
		});
	}
);

export const editTrialSettings = createAsyncThunk(
	`${sliceName}/getTrialSettings`,
	(args, thunkAPI) => {
		return trialSettingsService
			.editTrialSettings(args.id, args.minAllowedViewerVersion, args.onceAYear)
			.catch((error) => {
				return thunkAPI.rejectWithValue(error);
			});
	}
);

const trialSettingsSlice = createSlice({
	name: sliceName,
	initialState,
	reducers: {},
	extraReducers: {
		[editTrialSettings.fulfilled]: (state, action) => {
			state.minAllowedViewerVersion = action.payload.minAllowedViewerVersion;
			state.onceAYear = action.payload.onceAYear;
		},

		[getTrialSettings.fulfilled]: (state, action) => {
			state.minAllowedViewerVersion = action.payload.minAllowedViewerVersion;
			state.onceAYear = action.payload.onceAYear;
			state.isFetching = false;
		},

		[getTrialSettings.pending]: (state) => {
			state.isFetching = true;
			state.fetchingError = null;
		},

		[getTrialSettings.rejected]: (state, action) => {
			state.isFetching = false;
			state.fetchingError = action.payload;
		},
	},
});

const { reducer } = trialSettingsSlice;

export const trialSettingsSelectors = {
	state: (state) => state[sliceName],
	selectMinAllowedViewerVersion: (state) => state[sliceName].minAllowedViewerVersion,
	selectOnceAYear: (state) => state[sliceName].onceAYear,
	isFetching: (state) => state[sliceName].isFetching,
	fetchingError: (state) => state[sliceName].fetchingError,
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/trialSettingsSlice.js